import React, { Component } from 'react';
import Flight from './Flight'

class FlightsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }


  render() {
    //console.log("[FlightsList.js] flightData")
    //console.log(this.props.flightData)
    if (this.props.flightData !== null && this.props.flightData !== undefined && this.props.flightData.length !== 0) {
      const data = this.props.flightData;
      const flightsCount = data.length;
      //console.log("[FlightsList.js] data")
      //console.log(data)
      const flights_html = data.map(
        (name, index) => {
          return <Flight key={index} data={name} />
        });
      return(
        <div className="container mt-4">
          <div className="row justify-content-center">
            <div className="col-sm-12 col-lg-10">
              <div className="alert alert-primary alert-dismissible fade show mb-3" role="alert">
                <p className="mb-0">Choose your flight below. The selected flight's details will be imprinted on your ticket.</p>
              </div>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <small className="text-muted">Showing {flightsCount} {flightsCount === 1 ? 'flight' : 'flights'}</small>
              </div>
              <div className="table-responsive">
                <table className="table table-hover">
                  <caption className="sr-only">Available flights</caption>
                  <tbody>
                    {flights_html}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.props.flightData !== null && this.props.flightData !== undefined && this.props.flightData.length === 0) {
        return(
          <div className="container mt-2">
            <div className="row justify-content-center">
              <div className="alert alert-warning" role="alert">
              <h6>Sorry, no flights were found.</h6>
              <p><strong>Please try another date or destination!</strong><br/>
              <strong>Make sure you choose a valid destination from the dropdown menu!</strong></p>
              </div>
            </div>
          </div>
        );
    } else {
      if (this.props.loadingFlights) {
        return (
          <div className="container my-5" aria-live="polite">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <div className="d-flex align-items-center justify-content-center">
                  <div className="spinner-border text-primary me-3" role="status" aria-hidden="true"></div>
                  <span className="fs-5">Searching flights…</span>
                </div>
              </div>
            </div>
          </div>
        );
      }
      else if (!this.props.firstSearchDone) {
        return (
          <div className="container mt-2">
            <div className="row justify-content-center">
              <div className="alert alert-secondary" role="alert">
                <p><strong>Fill in the form above and receive your ticket in just 30 seconds.</strong></p>
              </div>
            </div>
          </div>
        )
      }
      else {
        return (
          <div className="container">
            <div className="row justify-content-center">
              <p>No Flights found.</p>
            </div>
          </div>
        );
    }
    }
  }
}

export default FlightsList
